import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingMembershipFragment } from 'generated/resources/graphql'

import { useTrainingsContext } from 'modules/trainings/hooks/Trainings/useTrainingsContext'

const EmployeesTrainingCertificates = () => {
  const { trainingId } = useParams()
  const { trainings } = useTrainingsContext()
  const { employeeAccessId, trainingMemberships } = useOutletContext<{
    employeeAccessId: string
    trainingMemberships: TrainingMembershipFragment[]
  }>()
  const training = trainings.find((t) => t.id === String(trainingId))
  const trainingMembership = trainingMemberships.find(
    (membership) =>
      membership.trainingId === String(trainingId) && membership.accessId === employeeAccessId
  )

  return <Outlet context={{ training, employeeAccessId, trainingMembership }} />
}

export default EmployeesTrainingCertificates
